<template>
  <form-label
    :label="label"
    :class-name="formLabelClassName"
    :is-required="isRequired"
  >
    <template #label>
      <slot name="label" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #body>
      <component
        :is="tag"
        :value.prop="value"
        :type="type"
        :class="className"
        :placeholder="placeholder"
        v-bind="$attrs"
        class="pega-form-item"
        data-test="item"
        @input="update"
        @keypress="keypress"
      >
        {{ value }}
      </component>
    </template>
    <template #error>
      <slot name="error" />
    </template>
  </form-label>
</template>

<script>
import FormLabel from '@/components/atoms/FormLabel'

export default {
  components: {
    FormLabel
  },
  props: {
    tag: {
      type: String,
      default: 'input'
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    className: {
      type: [String, Array, Object],
      default: ''
    },
    formLabelClassName: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    isRequired: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    update (e) {
      this.$emit('input', e.target.value)
      this.$emit('change', e.target.value)
    },
    keypress (e) {
      this.$emit('keypress', e)
    }
  }
}
</script>
